// 公共案件池 
var RobberyCase = function () { return import('~/pages/common-casespool-manage/robbery-case.vue'); };
var CreditRepairCase = function () { return import("~/pages/common-casespool-manage/credit-repair-case.vue"); };
export default [
    {
        path: '/common-casespool-manage/robbery-case',
        name: 'robbery-case',
        component: RobberyCase
    },
    {
        path: '/common-casespool-manage/credit-repair-case',
        name: 'credit-repair-case',
        title: "信修案件",
        component: CreditRepairCase
    }
];
